import React, { useEffect, useState } from 'react'
import Toggle from '../Toggle/Toggle'
import { useForm, useWatch } from 'react-hook-form'
// import ErrorMessage from '../ErrorMessage/ErrorMessage'
// import { retrieveAddress } from '../../services/api/orders'
import Invoice3rdPartyForm from './Invoice3rdPartyForm'
import styles from './Invoice3rdParty.module.scss'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface Invoice3rdPartyValues {
    name?: string
    emailAddress?: string
    street?: string
    city?: string
    extension?: string
    zipcode?: string
    houseNumber?: string
}

interface Invoice3rdPartyProps {
    isChecked?: boolean
    defaultValues?: Invoice3rdPartyValues
    isEnabled?: boolean
    onChange?(isActive: boolean, values: any, isValid: boolean): void
}

const Invoice3rdParty: React.FunctionComponent<Invoice3rdPartyProps> = ({
    isChecked = false,
    defaultValues,
    isEnabled = false,
    onChange
}) => {
    const [isActive, setIsActive] = useState<boolean>(isEnabled ?? false)

    const { register, control, getValues, setValue, formState, trigger } = useForm({
        defaultValues: defaultValues,
        mode: 'onChange',
        reValidateMode: 'onChange'
    })
    const values = useWatch({ control, disabled: !isActive }) // Always current form values

    useEffect(() => {
        if (Object.keys(values).length > 0) {
            onChange?.(isActive, values, formState.isValid)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values, formState.isValid, isActive])

    let alertClass = 'border rounded-lg text-sm px-4 lg:px-6 py-3 flex items-start'

    if (!isEnabled) {
        alertClass += ' ' + styles.greyAlert
    } else {
        alertClass += ' ' + styles.greenAlert
    }

    return (
        <div className='flex flex-col space-y-4 p-4 md:px-6 border-top w-full lg:w-8/12'>
            <Toggle disabled={!isEnabled} checked={isActive} onChange={setIsActive} label='Facturatie aan klant' />
            {!isEnabled && (
                <div className={`${alertClass}`}>
                    <DynamicFaIcon iconName='info-circle' className='mr-2 text-base mt-0.5' />
                    <span>
                        Deze optie is uitgeschakeld omdat een of meerdere producten niet geschikt zijn voor facturatie
                        aan de klant:
                    </span>
                </div>
            )}
            {isEnabled && (
                <div className={`${alertClass}`}>
                    <DynamicFaIcon iconName='info-circle' className='mr-2 text-base mt-0.5' />
                    <span>
                        {isActive && (
                            <>
                                <i>(Zet deze optie uit als u zelf de factuur wilt betalen).</i> <br />
                            </>
                        )}
                        {!isActive
                            ? 'Kies deze optie als de factuur niet naar jouw kantoor, maar naar de klant moet gaan.'
                            : 'Vul de gegevens van de klant in. Na plaatsen van de opdracht ontvangt de klant een e-mail om de opdracht te bevestigen.'}
                    </span>
                </div>
            )}

            {isActive && (
                <Invoice3rdPartyForm
                    register={register}
                    formState={formState}
                    getValues={getValues}
                    setValue={setValue}
                    trigger={trigger}
                    autoComplete
                />
            )}
        </div>
    )
}

export default Invoice3rdParty
